import { Component } from '@angular/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-button',
  templateUrl: './formly-button.component.html',
  styleUrl: './formly-button.component.scss',
})
export class FormlyButtonComponent extends FormlyFieldBaseComponent {
  defaultOptions = {
    props: { type: 'button', btnClass: 'primary' },
  };

  onClick(event: any) {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }
}
